import { Message } from "@apis:message/message";
import { Sender } from "@pages:app/talk/const";

export interface ChatMessage {
  sender: Sender;
  text: string;
  references: Message["GET_ONE"]["Response"]["docs"] | null;
  messageId: string;
  conversationId: string | undefined;
  key: string;
}

function splitMessagesBySender(message: Message["GET_ONE"]["Response"]) {
  return [
    {
      sender: Sender.User,
      text: message.question,
      references: null,
      messageId: message.id,
      conversationId: message.conversationId,
      key: `User: ${message.id} ${message.createdAt}`,
    },
    {
      sender: Sender.Nemo,
      text: message.answer,
      references: message.docs,
      messageId: message.id,
      conversationId: message.conversationId,
      key: `Nemo: ${message.id} ${message.createdAt}`,
    },
  ];
}

export function convertMessagesToChat(
  messages?: Message["GET_ONE"]["Response"][],
) {
  const sortedMessages = messages || [];

  return sortedMessages
    .map((message) => {
      return splitMessagesBySender(message);
    })
    .flat();
}
